import { require200Status } from "../../utils/response.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
function withdrawEndpoints(builder) {
  return {
    withdraw: builder.mutation({
      invalidatesTags: ["funding-tx"],
      query: (body) => ({
        url: `/member/withdraw`,
        validateStatus: require200Status,
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec()
    }),
    getWithdrawInfo: builder.query({
      providesTags: ["withdraw-info"],
      query: ({ query }) => ({
        url: `/member/withdraw/info${parseQs(query)}`,
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  withdrawEndpoints as default
};
